export default __webpack_public_path__ + "static/media/inhouse-icon1.91917094.svg";